import { useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";
import FilePanel from "./FilePanel";

const FileModal = ({
  data,
  openFileModal,
  setOpenFileModal,
  outputClient,
  setOutputClient,
  files,
  setFiles,
  superContainers,
  clientName,
  clientCode,
  clientAddress,
  tags,
  clientRegisteredWeight,
  comments,
  wasteCategoryName,
  checkStatus,
  cameraId,
  toCharacterization,
  clientId,
}) => {
  const { t } = useTranslation();
  const [docViewerOpen, setDocViewerOpen] = useState(false);

  const handleClose = () => setOpenFileModal(false);

  return (
    <Modal
      isOpen={openFileModal}
      toggle={handleClose}
      contentClassName="rounded-lg char-modal-content"
      style={{ maxWidth: docViewerOpen ? "900px" : "560px" }}
      centered
    >
      <ModalHeader
        className="char-modal-header"
        close={
          <button
            type="button"
            onClick={handleClose}
            className="char-modal-header-close"
            aria-label={t("Close")}
          >
            <i className="fas fa-times char-modal-header-close-icon" />
          </button>
        }
      >
        <span className="char-modal-header-title">
          {t("Imported documents")}
        </span>
      </ModalHeader>
      <ModalBody className="char-modal-body">
        <FilePanel
          data={data}
          outputClient={outputClient}
          setOutputClient={setOutputClient}
          files={files}
          setFiles={setFiles}
          superContainers={superContainers}
          clientName={clientName}
          clientCode={clientCode}
          clientAddress={clientAddress}
          tags={tags}
          clientRegisteredWeight={clientRegisteredWeight}
          comments={comments}
          wasteCategoryName={wasteCategoryName}
          checkStatus={checkStatus}
          cameraId={cameraId}
          toCharacterization={toCharacterization}
          clientId={clientId}
          presentation="followUp"
          hideTitle
          onClose={handleClose}
          onDocViewerChange={setDocViewerOpen}
        />
      </ModalBody>
    </Modal>
  );
};

export default FileModal;
